
























































































































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { TbGoodsClass,TbGoods, TbSettingsPad } from '@/http';
import { fmoney } from '@/common/money';
import { imageDialog } from '@/components';
import { ImagePreview } from 'vant';
const { userAgent } = navigator;
  const isAndroid =
    userAgent.indexOf("Android") > -1 ||
    userAgent.indexOf("android") > -1 ||
    userAgent.indexOf("Adr") > -1; // android终端
@Component({
    components: {
    },
})
export default class productList extends Vue {
    public $refs: {
        imageDialog:HTMLFormElement;
    };
    @Prop({
        default:false
    })
    isGift:Boolean;
    @Prop({
        default:false
    })
    isNoCode:Boolean;
    @Prop({
        default:false
    })
    mulChangeDisable:Boolean;

    fmoney= fmoney;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    /**分类弹窗 */
    showClassPopover = false;
    classList = [];

    /**排序弹窗 */
    showSortPopover = false;
    sortOption=[
        {
            label:"上架时间降序",
            value:1,
        },
        {
            label:"商品库存降序",
            value:2,
        },
        {
            label:"商品售价降序",
            value:3,
        },
        {
            label:"上架时间升序",
            value:4,
        },
        {
            label:"商品库存升序",
            value:5,
        },
        {
            label:"商品售价升序",
            value:6,
        },
    ]
    sortValue=1;

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

 
    /**是否允许负库存 */
    @Prop({
        default:true
    })
    isZeroStock:Boolean;

    get className(){
        let str = "";
        if(this.searchValue.goodsClassId){
            str = this.classList.some(v=>v.id==this.searchValue.goodsClassId)?this.classList.find(v=>v.id==this.searchValue.goodsClassId).name:'';
        }else{
            str= "全部分类";
        }
        return str;
    }

    get sortName(){
        let str = "";
        str = this.sortOption.some(v=>v.value==this.sortValue)?this.sortOption.find(v=>v.value==this.sortValue).label:""; 
        return str;
    }

    searchValue = {
        name:"",
        goodsClassId:"",
        timeSort:0,
        sort:null,
        stockSort:null,
        skip:0,
        count:20
    }

    userInfo:any={};

    @Watch('searchValue.name')
    nameChange(val){
        this.getList();
        
    }

    created() {
    }
    
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        this.getClassList();
    }

    inputBlur(){
        // if (!isAndroid) {
        //     window.webkit.messageHandlers.getFocus.postMessage('getFocus');
        // }
    }

    /**获取分类下拉 */
    async getClassList(){
        let res = await TbGoodsClass.GetAllGoodsClassList({needGoodsCount:true});
        this.classList = res; 
    }
    async chooseClass(id){
        this.searchValue.goodsClassId = id;
        this.showClassPopover = false;
        await this.getList();
    }

    async changeSortXL(item){
        this.sortValue = item.value;
        this.showSortPopover = false;
        await this.sortFun();
    }
    /**排序 */
    async sortFun(){
        switch (this.sortValue) {
            case 1:
                this.searchValue.timeSort=0;
                this.searchValue.stockSort=null;
                this.searchValue.sort=null;
                break;
            case 2:
                this.searchValue.timeSort=null;
                this.searchValue.stockSort=0;
                this.searchValue.sort=null;
                break;
            case 3:
                this.searchValue.timeSort=null;
                this.searchValue.stockSort=null;
                this.searchValue.sort=2;
                break;
            case 4:
                this.searchValue.timeSort=1;
                this.searchValue.stockSort=null;
                this.searchValue.sort=null;
                break;
            case 5:
                this.searchValue.timeSort=null;
                this.searchValue.stockSort=1;
                this.searchValue.sort=null;
                break;
            case 6:
                this.searchValue.timeSort=null;
                this.searchValue.stockSort=null;
                this.searchValue.sort=3;
                break;
        
            default:
                break;
        }
        await this.getList();
    }
    /**提示弹窗 */
    async tipConfirm(){
       switch (this.tipType) {
        
       
        default:
            break;
       }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.searchValue.count=20;
      this.currentPage = 1;
      this.refreshing = true;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbGoods.GetTbGoodsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))
            this.list = this.searchValue.skip==0? res.items.map(v=>{
                return{
                    ...v,
                    sellingPrice:v.sellingPrice.toFixed(2),
                    discountPrice:v.discountPrice.toFixed(2),
                }
            }):this.list.concat(res.items.map(v=>{
                return{
                    ...v,
                    sellingPrice:v.sellingPrice.toFixed(2),
                    discountPrice:v.discountPrice.toFixed(2),
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            
            }
    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=20;
        this.total = 0;
        this.currentPage = 1;
        
        let res = await TbGoods.GetTbGoodsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId
            }))
        this.list = res.items.map(v=>{
            return{
                ...v,
                sellingPrice:v.sellingPrice.toFixed(2),
                discountPrice:v.discountPrice.toFixed(2),
            }
        });
        this.total  = res.totalCount;
        this.finished = false;
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            name:"",
            goodsClassId:"",
            timeSort:0,
            sort:null,
            stockSort:null,
            skip:0,
            count:20
        }
       
        this.getList();
    }

    /**结算 */
    settleFun(){
        this.$emit("settleFun");
    }
    /**选择商品 */
    chooseProduct(item){
        this.$emit('chooseProduct',item);
    }
    ImgUrl:string = ''
    /**预览图片 */
    viewImg(url){
        this.ImgUrl = url
        this.$nextTick(()=>{
            this.$refs.imageDialog.opens()
        })
    }
    showNoCode(){
        this.$emit("showNoCode");
    }
    addRemark(){
        this.$emit("addRemark");
    }
    changePrice(){
        this.$emit("changePrice");
    }
    giftFun(){
        this.$emit("giftFun");
    }
    changeSpecANum(val){
        this.$emit("changeSpecANum",val);
    }
    mulChangePrice(){
        this.$emit("mulChangePrice");
    }
    //扫码直接赋值相应商品
    giveProduct(arr){
        let newarr = [];
        newarr = arr;
        console.log('newarr',newarr);
        this.list = newarr;
        this.finished = true;
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/productList.vue